
<script>
export default {
  name: 'cart-actualize',
  components: {},
  data: () => ({
    isCardModalActive: true
  }),
  computed: {
    actualize() {
      return this.$store.getters['cart/getActualize']
    },
  },
  watch: {
    actualize: {
      handler() {
        if (this.actualize.type !== 'success') {
          this.$buefy.dialog.alert({
            title: 'Актуализации',
            message: this.actualize.errors.join('<br/>'),
            type: 'is-danger',
            hasIcon: true,
            icon: 'alert-circle',
            iconPack: 'mdi',
            onConfirm: this.closeModal
          })
        }
      },
      deep: true
    }
  },
  methods: {
    closeModal() {
      const services = {
        hotels: {
          action: 'cart/getHotelAccommodations',
          getter: 'cart/getHotelFormForSearch',
          indexField: 'hotelIndex'
        },
        flights: {
          action: 'cart/getFlights',
          getter: 'cart/getFlightFormForSearch',
          indexField: 'flightIndex'
        },
        transfers: {
          action: 'cart/getTransfers',
          getter: 'cart/getTransferFormForSearch',
          indexField: 'transferIndex'
        },
        insurances: {
          action: 'cart/getInsurances',
          getter: 'cart/getInsuranceFormForSearch',
          indexField: 'insuranceIndex'
        }
      }

      if (this.actualize.type === 'research') {
        this.actualize.errorsServices.forEach(({ service, serviceIndex }) => {
          const {
            action,
            getter,
            indexField
          } = services[service]

          this.$store.dispatch(action, {
            [`${indexField}`]: serviceIndex,
            form: {
              ...this.$store.getters[getter](serviceIndex),
              isRepeatedSearch: 1
            }
          })
        })
      }

      if (this.actualize.type === 'notActual') {
        this.$store.dispatch('cart/getActualize')
      }

      if (this.actualize.type === 'tourResearch') {
        this.$router.push({
          name: 'ToursSearch',
          query: {
            ...this.$store.getters['cart/getTourResearchForm']
          }
        })
      }

      this.$store.commit('cart/clearActualizeErrorsMessages')
    }
  }
}
</script>

<template>
  <div class="cart__actualize" />
</template>
